import { deleteRecord } from '@/entities/shared/record/delete-record';

export async function deleteDocument(id: string): Promise<void> {
  await deleteRecord('documents', id);
}
